import {  useEffect,useState} from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios"; 
import "../../styles/owner/HomeOwner.css"; // Import the CSS file for styling
import BASE_URL from "../../BaseUrl";

export default function PendingAdminsSection({message, setMessage, showMessage, setShowMessage,reloadAdmins,setReloadAdmins}) {

    const navigate = useNavigate();
    const [admins, setAdmins] = useState([]);
    


    //for edit admin info
    const [showEditAdminForm, setShowEditAdminForm] = useState(false);
    const [editAdmin, setEditAdmin] = useState(null);

    //for update admin plane
    const [updateAdminPlane, setUpdateAdminPlane] = useState(false);

    //for Deleting the admin info
    const [showDeleteAdmin, setShowDeleteAdmin] = useState(false);
    const [idToDelete, setIdToDelete] = useState("");

    // for reloadding the admins and courses
    const [reloadding, setReloadding] = useState(false);

    // for admin details popup
    const [showAdminDetails, setShowAdminDetails] = useState(false);
    const [adminDetails, setAdminDetails] = useState(null);

    

    // fetch admin to be edited
    const fetchAdminToEdit = (admin) => {
        setEditAdmin(admin);
        setShowEditAdminForm(true);
    }

    // send updated admin info to backend
    const updateAdmin = async (admin) => {
        await axios.put(`${BASE_URL}/owner/update-info`, admin, { withCredentials: true })
        .then((response) => {
            setMessage(response.data);
            setShowMessage(true);
            setShowEditAdminForm(false);

        }).catch((error) => {
            setMessage(error.response.data || "An error occurred while updating the admin.");
            setShowMessage(true);
            setShowEditAdminForm(false);
        })
        if(updateAdminPlane) {
            await axios.put(`${BASE_URL}/owner/update-plane`, admin, { withCredentials: true })
            .then((response) => {
                setMessage(response.data);
                setShowMessage(true);
                setUpdateAdminPlane(false);
            }).catch((error) => {
                setMessage(error.response.data || "An error occurred while updating the admin plane.");
                setShowMessage(true);
                setUpdateAdminPlane(false);
            });
            setUpdateAdminPlane(false);
        }
        setShowEditAdminForm(false);
        setEditAdmin(null);
        setReloadding(!reloadding); // toggle reloadding to refresh the admins list 
    }
    // delete admin function
    const deleteAdmin = () => {
        axios.delete(`${BASE_URL}/owner/delete-admin?id=${idToDelete}`, { withCredentials: true })
            .then((response) => {
                setReloadding(!reloadding); // toggle reloadding to refresh the admins list
                setMessage(response.data);
                setShowMessage(true);
                setShowDeleteAdmin(false);
                setIdToDelete("");
            }).catch((error) => {
                setMessage(error.response.data || "An error occurred while deleting the admin.");
                setShowMessage(true);
                setShowDeleteAdmin(false);});
            }

    const refreshAdmin = (adminId) => {
        axios.get(`${BASE_URL}/owner/refresh?adminId=${adminId}`, { withCredentials: true })
            .then((response) => {
                console.log(response.data);
                setMessage(response.data);
                setShowMessage(true);
                setReloadAdmins(!reloadAdmins); // toggle reloadding to refresh the admins list
            }).catch((error) => {
                setMessage(error.response.data || "An error occurred while refreshing the admin.");
                setShowMessage(true);
            });
    }
            
            
    useEffect(() => {
        axios.get(BASE_URL+"/owner/pending-admins", { withCredentials: true })
        .then((response) => {
            setAdmins(response.data);
        }).catch((error) => {
            navigate("/");
        });
    }, [reloadAdmins,navigate]);

    
    
    return (
        <div className="admins-section-container">
            <h2>التجديدات </h2>
            <table className="admins-table">
            <thead>
                <tr>
                <th>حذف</th>
                <th>تجديد</th>
                <th>عرض التفاصيل</th>
                <th>تعديل</th>
                <th>البريد الإلكتروني</th>
                <th>الاسم</th>
                </tr>
            </thead>
            <tbody>
            {admins.map((admin, index) => (
                <tr key={index} className="admin-card">
                <td><button onClick={() => {setIdToDelete(admin.id);setShowDeleteAdmin(true)}}>حذف</button></td>
                <td><button onClick={() => {refreshAdmin(admin.id)}}>تجديد</button></td>
                <td><button onClick={() => {setAdminDetails(admin);setShowAdminDetails(true)}}>عرض التفاصيل</button></td>
                <td><button onClick={()=>{fetchAdminToEdit(admin)}}>تعديل</button></td>
                <td>{admin.email}</td>
                <td>{admin.name}</td>
                </tr>
            ))}
            </tbody>
            </table>
            { showEditAdminForm && (
                <div className="edit-admin-form">
                    <h3>تعديل المدرس</h3>
                    <label>الاسم</label>
                    <input
                        type="text"
                        value={editAdmin.name}
                        onChange={(e) => setEditAdmin({ ...editAdmin, name: e.target.value })}/>
                    <label>البريد الإلكتروني</label>
                    <input
                        type="email"
                        value={editAdmin.email}
                        onChange={(e) => setEditAdmin({ ...editAdmin, email: e.target.value })} readOnly/>
                    <label>السعة</label>
                    
                    <input
                        type="number"
                        value={editAdmin.capacity}
                        onChange={(e) => {setEditAdmin({ ...editAdmin, capacity: e.target.value });setUpdateAdminPlane(true)}}/>
                    <label>الطلاب</label>
                    <input
                        type="number"
                        value={editAdmin.students}
                        onChange={(e) => {setEditAdmin({ ...editAdmin, students: e.target.value });setUpdateAdminPlane(true)}}/>
                    <label>المعلمين المساعدين</label>
                    <input
                        type="number"
                        value={editAdmin.assistants}
                        onChange={(e) => {setEditAdmin({ ...editAdmin, assistants: e.target.value});setUpdateAdminPlane(true)}}/>
                    <button className="update-admin-button" onClick={()=>{updateAdmin(editAdmin)}}>تحديث</button>
                    <button onClick={() => setShowEditAdminForm(false)}>إغلاق</button>
                </div>
            )}

            { showAdminDetails && (
                <div>
                <div className="admin-details-form" dir="rtl">
                    <h3>معلومات المدرس</h3>
                    <label>الاسم</label>
                    <input
                        type="text"
                        value={adminDetails.name}
                        readOnly/>
                    <label>البريد الإلكتروني</label>
                    <input
                        type="email"
                        value={adminDetails.email}
                        readOnly/>
                        <label>اسم المادة</label>
                    <input
                        type="text"
                        value={adminDetails.courseName}
                        readOnly/>
                    <label>السعة</label>
                    <input
                        type="number"
                        value={adminDetails.capacity}
                        readOnly/>

                    <label>السعة المستخدمة</label>
                    <input
                        type="number"
                        value={adminDetails.usedCapacity}
                        readOnly/>

                    <label>السعة المتاحة</label>
                    <input
                        type="number"
                        value={adminDetails.capacity-adminDetails.usedCapacity}
                        readOnly/>

                    <label>الطلاب</label>
                    <input
                        type="number"
                        value={adminDetails.students}
                        readOnly/>

                    <label>الطلاب الحاليون</label>
                    <input
                        type="number"
                        value={adminDetails.currentStudent}
                        readOnly/>
                    <label>المعلمين المساعدين</label>
                    <input
                        type="number"
                        value={adminDetails.assistants}
                        readOnly/>
                    <label>المساعدين الحاليين</label>
                    <input 
                        type="number"
                        value={adminDetails.currentAssistants}
                        readOnly/>
                    <button onClick={() => setShowAdminDetails(false)}>إغلاق</button>
                </div>
                <div></div>
                </div>
            )}

            { showDeleteAdmin && (
                <div className="delete-admin-confirmation">
                    <h3>هل أنت متأكد أنك تريد حذف هذا المدرس؟</h3>
                    <button onClick={() => deleteAdmin()}>نعم</button>
                    <button onClick={() => setShowDeleteAdmin(false)}>لا</button>
                </div>
            )}
        </div>
    );
}